import { Box, Button, Chip, Divider, Stack, Typography } from "@mui/material";
import React, { useEffect } from "react";
import SearchBar from "../components/SearchBar";
import { getData } from "../libs/firebase/firestore/getData";
import ResourceListTable from "../components/ResourceList/Table";
import { uuidv4 } from "../utilities/uuidv4";
import { getAllData } from "../libs/firebase/firestore/getAllData";
import ResourceListSaveDialog from "../components/ResourceList/SaveDialog";
import { uploadDataWithName } from "../libs/firebase/firestore/uploadDataWithName";
import FreeSoloCreateOptionDialog from "../components/FreeSoloWithDialog";
import { updateData } from "../libs/firebase/firestore/updateData";
import FreeSoloCreateOptionDialogClient from "../components/FreeSoloWithDialogClient";
import { uploadData } from "../libs/firebase/firestore/uploadData";
import AppBarResourceList from "../components/AppBar/ResourceList";
import { useNavigateToTop } from "../libs/useNavigateToTop";
import { useParams } from "react-router-dom";
import DateSelector from "../components/DateSelector";
import { firebaseDateToDateTime } from "../utilities/firebaseDateToDateTime";

function dataToSearchList(data) {
  let searchList = [];
  data.forEach((item) => {
    searchList.push({
      label: item,
      value: item,
    });
  });
  return searchList;
}

function ScreenEditResourceList({}) {
  const navigate = useNavigateToTop();

  // get the resource list id
  const { resourceListId } = useParams();

  // const for tag number
  const [tagNumber, setTagNumber] = React.useState(uuidv4());

  // state for the reource list
  const [resourceList, setResourceList] = React.useState([]);
  // state for the search items
  // const [searchItems, setSearchItems] = React.useState(["mulch", "soil"]);

  const [plants, setPlants] = React.useState([]);

  const [materials, setMaterials] = React.useState([]);

  // state for client name
  const [clientName, setClientName] = React.useState("");

  // state for client id
  const [clientId, setClientId] = React.useState("");

  // state for site name
  const [siteName, setSiteName] = React.useState("");

  // state to hold sites
  const [sites, setSites] = React.useState([]);

  // state for calendar
  const [open, setOpen] = React.useState(false);

  // state for date
  const [date, setDate] = React.useState(new Date());

  let searchItems = [...plants, ...materials];

  const handleOnNewOption = (newOption, onSuccess, onFail) => {
    // return;
    // add the new option to firebase

    // get the db to update
    let dbName =
      newOption.resourceCatagory === "plants" ? "plants" : "materials";
    getData(
      `${dbName}/all`,
      (data) => {
        let dataCollated = [...data.names, newOption.label];

        console.log(`trying to ${newOption.label} to ${dbName}`);
        updateData(
          { names: dataCollated },
          dbName,
          "all",
          () => {
            console.log(`added ${newOption.label} to ${dbName}`);
            // Success
            handleOnSelect(newOption.label);

            if (dbName === "plants") {
              setPlants(dataCollated);
            } else {
              setMaterials(dataCollated);
            }

            onSuccess();
          },
          onFail
        );
      },
      (error) => {
        onFail(error);
      }
    );
  };

  const handleOnSelect = (selected) => {
    if (!selected) return;
    // check if the selected item is already in the resource list
    let isAlreadyInResourceList = false;
    resourceList.forEach((item) => {
      if (item.name === selected) {
        isAlreadyInResourceList = true;
      }
    });

    // if the selected item is not in the resource list, add it
    if (!isAlreadyInResourceList) {
      setResourceList((prev) => [...prev, { name: selected, amount: 1 }]);
    }
  };

  const handleOnIncrement = (name) => {
    let newResourceList = [...resourceList];
    newResourceList.forEach((item) => {
      if (item.name === name) {
        item.amount += 1;
      }
    });
    setResourceList(newResourceList);
  };

  const handleOnDecrement = (name) => {
    let newResourceList = [...resourceList];
    let delted = false;
    newResourceList.forEach((item) => {
      if (item.name === name) {
        item.amount -= 1;

        // if the amount is 0, delete the item
        if (item.amount === 0) {
          handleOnDelete(name);
          delted = true;
          return;
        }
      }
    });
    if (delted) return;
    setResourceList(newResourceList);
  };

  const handleOnDelete = (name) => {
    let newResourceList = [...resourceList];
    newResourceList.forEach((item, index) => {
      if (item.name === name) {
        newResourceList.splice(index, 1);
      }
    });
    setResourceList(newResourceList);
  };

  const handleOnTagClick = () => {
    // copy the tag number to the clipboard
    navigator.clipboard.writeText(tagNumber);
  };

  const handleOnUpdate = () => {
    //  if client id is not set, retur

    // Go through the resourceList and split the items into plants and materials
    let selectedPlants = [];
    let selectedMaterials = [];
    resourceList.forEach((item) => {
      // is items in plants
      if (plants.includes(item.name)) {
        selectedPlants.push(item);
      } else {
        selectedMaterials.push(item);
      }
    });

    // create the reource list object
    let resourceListObject = {
      client: clientId,
      clientName,
      // site: siteName || "",
      tagNumber: tagNumber,
      plants: selectedPlants,
      materials: selectedMaterials,
      timeDateCreated: date,
    };

    // return;

    // save the resource list to firebase
    uploadDataWithName(
      resourceListObject,
      `resourceLists`,
      tagNumber,
      () => {
        console.log("saved", resourceListObject);
        // navigate home
        navigate("/");
      },
      (err) => {
        console.log(err);
      }
    );
  };

  useEffect(() => {
    // get the plants from firebase
    getData(
      "plants/all",
      (data) => {
        let searchItemsCollated = [...data.names];
        setPlants(data.names);

        // get the materials from firebase
        getData(
          "materials/all",
          (data) => {
            // searchItemsCollated = [...searchItemsCollated, ...data.names];
            // setSearchItems(searchItemsCollated);
            setMaterials(data.names);
          },
          (error) => {
            console.log(error);
          }
        );
      },
      (error) => {
        console.log(error);
      }
    );

    getData(
      `resourceLists/${resourceListId}`,
      (data) => {
        setResourceList([...data.plants, ...data.materials]);
        setClientName(data.clientName);
        setClientId(data.client);
        setTagNumber(data.tagNumber);
        setDate(firebaseDateToDateTime(data.timeDateCreated));
      },
      (error) => {
        console.log(error);
      }
    );

    getAllData("/sites").then((data) => {
      setSites(data);
    });

    // get the materials from firebase
  }, []);

  const handleChooseDate = () => {
    setOpen(true);
  };
  return (
    <Box>
      <AppBarResourceList />

      <Box
        style={{
          padding: "2rem",
          margin: "auto 0",
        }}
      >
        {/* Title and subtitle */}
        <Typography variant="h5">Resource List</Typography>
        <Typography variant="subtitle1">This is a list of resources</Typography>

        <Stack
          spacing={4}
          direction={"column"}
          style={{
            margin: "1rem 0",
          }}
        >
          {/* Client name, tag number and site name */}
          <Chip
            onClick={handleChooseDate}
            label={date.toLocaleDateString("en-CA", {
              day: "numeric",
              month: "long",
            })}
            style={{ width: "fit-content" }}
          />
          {open && (
            <DateSelector
              date={date}
              onSelect={(date) => {
                setOpen(false);
                setDate(date);
              }}
            />
          )}
          {/* Client name, tag number and site name */}
          <Chip
            onClick={handleOnTagClick}
            label={tagNumber}
            style={{ width: "fit-content" }}
          />

          <FreeSoloCreateOptionDialog
            options={dataToSearchList(searchItems)}
            onSelect={handleOnSelect}
            onNewOption={handleOnNewOption}
          />
        </Stack>

        {/* Horizontal divider */}
        <Divider
          sx={{
            my: 2,
          }}
        />
        <ResourceListTable
          onIncrement={handleOnIncrement}
          onDecrement={handleOnDecrement}
          onDelete={handleOnDelete}
          data={resourceList}
        />

        {/* <ResourceListSaveDialog
        onSave={handleOnSave}
        clients={clients}
        sites={sites}
      /> */}
        <Button
          disabled={resourceList.length === 0 || !clientName}
          style={{
            marginTop: "2rem",
            alignSelf: "center",
          }}
          variant="contained"
          onClick={handleOnUpdate}
        >
          Update
        </Button>
      </Box>
    </Box>
  );
}

export default ScreenEditResourceList;
